module.exports = __webpack_public_path__ + "static/media/button-round-arrow-corner-up.cc5ec1d6.svg";